// extracted by mini-css-extract-plugin
export default {"saveAsNewTemplate":"SaveAsNewTemplate_saveAsNewTemplate__5+V25"};